const options = {
  5: "bg-zinc-700/5",
  10: "bg-zinc-700/10",
  25: "bg-zinc-700/25",
  50: "bg-zinc-700/50",
  75: "bg-zinc-700/75",
  90: "bg-zinc-700/90",
  100: "bg-zinc-700",
};

const from = {
  5: "from-zinc-700/5",
  10: "from-zinc-700/10",
  25: "from-zinc-700/25",
  50: "from-zinc-700/50",
  75: "from-zinc-700/75",
  90: "from-zinc-700/90",
  100: "from-zinc-700",
};

export default function getBackgroundZinc700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
